
export default {
  props: {
    usps: {
      type: Array,
      default: () => []
    }
  }
}
